import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Grid, Typography } from '@material-ui/core';
import { orderBy } from 'lodash';
import { FormattedMessage } from 'react-intl';
import { Container, Button } from 'components/basics';
import SubIntroBackground from 'components/pages/Solution/Marketing/SubIntroBackground';
import { breakpoint } from 'utils/mediaQueries';
import { colors } from 'styles';
import PlanCard from './PlanCard/PlanCard';

const CardGrid = styled(Grid)`
  position: relative;
  padding-bottom: 0;
  ${breakpoint.down('lg')`
  padding-top: 4rem;padding-bottom: 2rem;`}
  ${breakpoint.down(
    'md'
  )`margin-top:-6rem;padding-top:9rem;padding-bottom: 2rem;`}
  ${breakpoint.down('sm')`
   padding-top:6rem;margin-top:-3rem`};
`;

const SeeFeaturesLink = styled.a`
  text-decoration: none;
  color: ${colors.lightBlue};
  font-weight: bold;
`;

const SyntheticPlansBlock = ({
  plans,
  isMonthlySelected,
  setMonthlySelected,
}) => {
  const [width, setWidth] = useState(200);
  const [heightHeader, setHeightHeader] = useState(0);
  const [heightIntro, setHeightIntro] = useState(0);
  const [heightTitleIntro, setHeightTitleIntro] = useState(0);

  const updateDimensions = () => {
    const headerNav = document.getElementById('headerNav');
    const heightIntroDim = document.getElementById('cardGrid');
    const heightTitleIntroDim = document.getElementById('titleIntroBlock');
    setWidth(window.innerWidth);
    setHeightHeader(headerNav && headerNav.offsetHeight);
    setHeightIntro(heightIntroDim && heightIntroDim.offsetHeight);
    setHeightTitleIntro(
      heightTitleIntroDim && heightTitleIntroDim.offsetHeight
    );
  };

  useEffect(() => {
    window.addEventListener('resize', updateDimensions);
    return () => window.removeEventListener('resize', updateDimensions);
  }, []);

  useEffect(() => {
    const headerNav = document.getElementById('headerNav');
    if (headerNav) {
      updateDimensions();
    }
  }, [heightHeader]);

  const heightBackground = heightHeader + heightIntro + 216;
  const heightTitle = heightTitleIntro + heightHeader + 96;
  return (
    <Container>
      <CardGrid container id="cardGrid" justify="space-around">
        {orderBy(plans, ({ frontmatter: plan }) => plan.index).map(
          ({ frontmatter: plan }) => (
            <Grid item>
              <PlanCard plan={plan} isMonthlySelected={isMonthlySelected} />
            </Grid>
          )
        )}
      </CardGrid>
      <SubIntroBackground
        widthWindow={width}
        heightBackground={heightBackground}
        heightTitle={heightTitle}
      />
      <Typography variant="body2" style={{marginTop: '1em'}}>
        <SeeFeaturesLink href="#detailedPlansContainer">
        <FormattedMessage id="pricing.syntheticBlock.seeFeatures" />
        </SeeFeaturesLink>
      </Typography>
    </Container>
  );
};

export default SyntheticPlansBlock;
